import React from "react";
import { cn } from "@/lib/utils";

// Official WhooLive brand mark (app icon) + optional wordmark.
// The icon asset lives in /public/whoolive-logo.png.
export function Logo({
  size = 40,
  withWordmark = true,
  className,
  textClassName,
  wordmarkColor = "text-foreground",
  testId = "brand-logo",
}) {
  return (
    <span data-testid={testId} className={cn("flex items-center gap-2.5", className)}>
      <img
        src="/whoolive-logo.png"
        alt="WhooLive"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="rounded-[22%] object-cover shadow-sm ring-1 ring-black/5"
      />
      {withWordmark && (
        <span
          className={cn(
            "font-heading text-xl font-extrabold tracking-tight",
            wordmarkColor,
            textClassName
          )}
        >
          Whoo<span className="text-brand">Live</span>
        </span>
      )}
    </span>
  );
}

export default Logo;
